export default __webpack_public_path__ + "static/media/logo-ana.208c356e.webp";